const SUBSCRIPTION_PRODUCT_CODES = new Set([
  'monthly-4',
  'monthly-8',
  'monthly-16',
  'monthly-32',
  'monthly-48',
]);

export const SINGLE_LESSON_PRODUCT_CODE = 'single-lesson-25';

export const normalizePurchaseProductCode = (value) => {
  const code = String(value || '').trim().toLowerCase();
  return SUBSCRIPTION_PRODUCT_CODES.has(code) || code === SINGLE_LESSON_PRODUCT_CODE ? code : '';
};

export const getPurchaseIntent = (search = '') => {
  const params = new URLSearchParams(search);
  return {
    productCode: normalizePurchaseProductCode(params.get('product')),
    openCheckout: params.get('checkout') === '1',
  };
};

export const withPurchaseProduct = (path, productCode) => {
  const normalizedCode = normalizePurchaseProductCode(productCode);
  if (!normalizedCode) return path;

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}product=${encodeURIComponent(normalizedCode)}`;
};

export const getPostSignupPurchasePath = (productCode) => {
  const normalizedCode = normalizePurchaseProductCode(productCode);
  return normalizedCode
    ? `/Student-dashboard/buy-lessons?product=${encodeURIComponent(normalizedCode)}&checkout=1`
    : '/Student-dashboard/dash';
};
